'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of add patient web
 */ const AddPatientWeb = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "19.9531",
                y: "31.6211",
                width: "63.9459",
                height: "37.2433",
                rx: "3.46892",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.9531 62.1255V65.4044C19.9531 67.3203 21.5062 68.8734 23.422 68.8734H80.4301C82.346 68.8734 83.8991 67.3203 83.8991 65.4044V62.1255H19.9531Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42.1602",
                y: "68.8594",
                width: "19.6757",
                height: "6.04325",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "35.2734",
                y: "74.7676",
                width: "33.3081",
                height: "1.68649",
                rx: "0.843243",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M47.1328 41.9225C47.1328 44.6418 49.3604 46.845 52.1055 46.845C54.8507 46.845 57.0783 44.6418 57.0783 41.9225C57.0783 39.2032 54.8526 37 52.1055 37C49.3585 37 47.1328 39.2032 47.1328 41.9225Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M56.3691 48.1543C55.1519 48.9785 53.6845 49.4613 52.1052 49.4613C50.526 49.4613 49.0567 48.9785 47.8395 48.1543C45.4393 49.4934 43.8164 52.0452 43.8164 54.9779V56.0001C43.8164 57.1053 44.717 57.9993 45.8261 57.9993H58.3825C59.4916 57.9993 60.3922 57.1035 60.3922 56.0001V54.9779C60.3922 52.0452 58.7693 49.4934 56.3691 48.1543Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "60.5135",
                cy: "53.5135",
                r: "3.51351",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("line", {
                x1: "60.4823",
                y1: "51.7342",
                x2: "60.4823",
                y2: "55.3162",
                stroke: "#FAFFFC",
                strokeWidth: "0.941071",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ jsxRuntime.jsx("line", {
                x1: "62.3185",
                y1: "53.5545",
                x2: "58.7365",
                y2: "53.5545",
                stroke: "#FAFFFC",
                strokeWidth: "0.941071",
                strokeLinecap: "round"
            })
        ]
    });
};

exports.AddPatientWeb = AddPatientWeb;
//# sourceMappingURL=AddPatientWeb.cjs.map
